import { render, staticRenderFns } from "./BaseIcon.vue?vue&type=template&id=429dfa7e&scoped=true"
import script from "./BaseIcon.vue?vue&type=script&lang=js"
export * from "./BaseIcon.vue?vue&type=script&lang=js"
import style0 from "./BaseIcon.vue?vue&type=style&index=0&id=429dfa7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429dfa7e",
  null
  
)

export default component.exports